import React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import Button from './Button';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  itemName: string;
  itemType: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
  message?: string;
}

/**
 * 削除確認モーダル
 *
 * SUPER_ADMIN権限での削除操作に使用する統一モーダルコンポーネント
 */
export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  itemName,
  itemType,
  onConfirm,
  onCancel,
  isDeleting = false,
  message,
}) => {
  if (!isOpen) return null;

  const defaultMessage = `${itemType}「${itemName}」を削除しますか？この操作は取り消せません。`;

  return (
    <div className='fixed inset-0 z-60 flex items-center justify-center p-4 bg-black/50'>
      <div className='bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6'>
        <div className='flex items-center mb-4'>
          <TrashIcon className='h-6 w-6 text-red-600 dark:text-red-400 mr-3' />
          <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>削除の確認</h3>
        </div>

        <p className='text-sm text-gray-600 dark:text-gray-300 mb-6'>{message || defaultMessage}</p>

        <div className='flex justify-end space-x-3'>
          <Button variant='secondary' onClick={onCancel} size='md' disabled={isDeleting}>
            キャンセル
          </Button>
          <Button variant='danger' onClick={onConfirm} size='md' disabled={isDeleting}>
            <TrashIcon className='h-4 w-4 mr-2' />
            {isDeleting ? '削除中...' : '削除する'}
          </Button>
        </div>
      </div>
    </div>
  );
};
